export enum GetNextEventType {
  CALL_CONTACT_EVENT = 'CallContactEvent',
  MUTE_EVENT = 'Mute',
  UPDATE_PERMISSIONS_EVENT = 'UpdatePermissions',
  AGENT_SESSION_START_EVENT = 'AgentSessionStart',
  AGENT_SESSION_END_EVENT = 'AgentSessionEnd',
  REMOTE_AGENT_SESSION_END_EVENT = 'RemoteAgentSessionEnd',
  AGENT_STATE_EVENT = 'AgentState',
  UPDATE_UNAVAILABLE_CODE_EVENT = 'UpdateUnavailableCodes',
  AGENT_LEG_EVENT = 'AgentLeg',
  UPDATE_INDICATORS = 'UpdateIndicators',
  INDICATOR = 'Indicator',
}
